import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { FaTrash } from "react-icons/fa";
import { IoClose } from "react-icons/io5"; // Import simple cross icon
import "./CustomOrderImageUpload.css";

const CustomOrderImageUpload = ({ onUpload, existingImages = [] }) => {
  const [images, setImages] = useState(existingImages);
  const [showPopup, setShowPopup] = useState(false);

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prevImages) => [...prevImages, ...newImages]);
    onUpload([...images, ...newImages]); // Notify parent component
    event.target.value = "";
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    onUpload(updatedImages); // Notify parent component
  };

  const handleSave = () => {
    setShowPopup(false);
    onUpload(images); // Save the updated images
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  return (
    <div className="custom-order-image-upload-container">
      <div className="custom-order-image-upload-input-box">
        <input
          type="text"
          readOnly
          className="custom-order-image-upload-input-text"
          style={{ height: "27px" }} // Match height with other inputs
        />
        <button
          type="button"
          onClick={() => setShowPopup(true)}
                  className="custom-order-image-upload-add-button"
                  style={{ height: "27px" }} 
        >
          <FiPlus size={20} />
        </button>
      </div>

      {showPopup && (
        <div className="custom-order-image-upload-popup-overlay">
          <div className="custom-order-image-upload-popup">
            <h2 className="custom-order-image-upload-popup-header">
              Uploaded Images
            </h2>
            <div className="custom-order-image-upload-preview-grid">
              {images.map((img, index) => (
                <div
                  key={index}
                  className="custom-order-image-upload-image-container"
                >
                  <img
                    src={img.preview || img}
                    alt={`preview-${index}`}
                    className="custom-order-image-upload-preview-image"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveImage(index)}
                    className="custom-order-image-upload-remove-button"
                  >
                    X {/* Always visible cross icon */}
                  </button>
                </div>
              ))}
              {images.length < 5 && (
                <label className="custom-order-image-upload-file-input-wrapper">
                  <FiPlus className="custom-order-image-upload-plus-icon" />
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    className="custom-order-image-upload-file-input"
                  />
                </label>
              )}
            </div>
            <div className="custom-order-image-upload-popup-buttons">
              <button
                type="button"
                onClick={handleCancel}
                className="custom-order-image-upload-cancel-button"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSave}
                className="custom-order-image-upload-save-button"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomOrderImageUpload;
